<script setup>
import { ref, onMounted, computed } from "vue";
import { formatDate } from "@/utils/formatDate";
import deadlineChartTable from "@/components/Charts/deadlineChartTable.js";
import ProgressBar from "@/components/data/ProgressBar.vue";
import LineChart from "@/components/Charts/LineChart.vue";
import ChartTable from "@/components/ChartTable.vue";
const { chartOptions } = deadlineChartTable;

const props = defineProps({
  construction: {
    type: Object,
    required: true,
  },
});

const isLoading = ref(true);
const allContractors = ref([]);
const contractor = ref({});
const currentIndex = ref(0);
const labels = computed(() =>
  contractor.value.chartList
    ? contractor.value.chartList.map((e) => formatDate(e.date.seconds))
    : [],
);
const plan = computed(() =>
  contractor.value.chartList
    ? contractor.value.chartList.map((e) => e.plan)
    : [],
);
const fact = computed(() =>
  contractor.value.chartList
    ? contractor.value.chartList.map((e) => e.fact)
    : [],
);
const deviation = computed(() =>
  contractor.value.chartList
    ? contractor.value.chartList.map((e) => e.deviation)
    : [],
);

const chartData = computed(() => ({
  labels: [...new Set(labels.value)],
  datasets: [
    {
      label: "Plan",
      data: plan.value,
      borderColor: "#4285F4",
      backgroundColor: "#4285F4",
      pointBorderColor: "#4285F4",
      pointBackgroundColor: "#4285F4",
      fill: false,
      tension: 0.1,
    },
    {
      label: "Data",
      data: fact.value,
      borderColor: "#FFA726",
      backgroundColor: "#FFA726",
      pointBorderColor: "#FFA726",
      pointBackgroundColor: "#FFA726",
      fill: false,
      tension: 0.1,
    },
    {
      label: "Deviation",
      data: deviation.value,
      borderColor: "#FF5252",
      backgroundColor: "#FF5252",
      pointBorderColor: "#FF5252",
      pointBackgroundColor: "#FF5252",
      fill: false,
      tension: 0.1,
    },
  ],
}));

const showNextContractor = () => {
  currentIndex.value = (currentIndex.value + 1) % allContractors.value.length;
  contractor.value = allContractors.value[currentIndex.value];
};

const showPreviousContractor = () => {
  currentIndex.value =
    (currentIndex.value - 1 + allContractors.value.length) %
    allContractors.value.length;
  contractor.value = allContractors.value[currentIndex.value];
};

const {
  ValueRequest_String,
} = require("../../../proto-out/IMultiStatisticsService_pb");

const {
  MultiStatisticsServiceClient,
} = require("../../../proto-out/IMultiStatisticsService_grpc_web_pb");

const store = useStore();
import { useStore } from "vuex";

let authToken = computed(() => store.getters["users/tokenUser"]);
let serverUrl = computed(() => store.getters["appData/getServerUrl"]);

const fetchDataFromGrpc = async () => {
  try {
    const client = new MultiStatisticsServiceClient(serverUrl.value);
    const metadata = { Authorization: `Bearer ${authToken.value}` };
    const request = new ValueRequest_String();
    request.setValue(props.construction.actualinstance);

    const getContractorsDynamicsData = await new Promise((resolve, reject) => {
      client.getContractorsDynamics(request, metadata, (err, response) => {
        if (err) {
          console.error("gRPC Error:", err.message);
          reject(new Error("Failed to fetch data from gRPC"));
        } else {
          resolve(response.toObject());
        }
      });
    });

    allContractors.value = getContractorsDynamicsData.valuesList;
    contractor.value = getContractorsDynamicsData.valuesList[0];
    isLoading.value = false;
  } catch (error) {
    console.error(error);
    // throw error;
  }
  isLoading.value = false;
};
onMounted(() => {
  fetchDataFromGrpc();
});
</script>

<template>
  <v-row style="width: 60%; padding-bottom: 1em; margin: 0 auto">
    <img
      src="@/assets/icons/left_line.svg"
      @click="showPreviousContractor"
      style="cursor: pointer"
    />
    <v-container class="custom-btn">
      <v-row class="align-center justify-space-between">
        <v-spacer></v-spacer>
        <v-col cols="6">
          <span class="label-text">
            {{ contractor.contractorname }}
          </span>
        </v-col>
        <v-col cols="auto">
          <!-- TODO days -->
          <span style="font-size: 0.8vw">20 дн.</span>
          <img src="@/assets/icons/arrow.svg" style="height: 1vw" />
        </v-col>
      </v-row>
    </v-container>
    <img
      src="@/assets/icons/right_line.svg"
      @click="showNextContractor"
      style="cursor: pointer"
    />
  </v-row>

  <v-container class="d-flex mb-3">
    <v-row align="center" class="ma-0">
      <ProgressBar
        title="ВРЕМЯ"
        :percents="contractor?.currentexecution?.plan"
        :size="0.8"
      />
    </v-row>
    <v-row align="center" class="ma-0">
      <ProgressBar
        title="СДАНО"
        :percents="contractor?.currentexecution?.fact"
        :size="0.8"
      />
    </v-row>
    <v-row align="center" class="ma-0">
      <ProgressBar
        title="ОТКЛОНЕНИЕ"
        :percents="contractor?.currentexecution?.deviation"
        :size="0.8"
      />
    </v-row>
  </v-container>

  <LineChart
    height="37"
    :chartData="chartData"
    :chartOptions="chartOptions"
  />
  <v-container fluid>
    <v-row>
      <v-col cols="2" style="padding-left: 50px; padding-top: 50px">
        <img src="@/assets/icons/Corps.svg" height="70vw" />
        <v-card-text style="color: #00a3ff; font-size: 0.9vw" class="pa-0">
          Корпус 1
        </v-card-text>
      </v-col>
      <v-col cols="1">
        <v-container class="vertical-line-container">
          <div class="glowing-line"></div>
        </v-container>
      </v-col>
      <v-col cols="6">
        <v-row class="mr-5 mt-5">
          <ChartTable :data="contractor" />
        </v-row>
      </v-col>
      <v-col cols="1">
        <v-container class="vertical-line-container">
          <div class="glowing-line"></div>
        </v-container>
      </v-col>
      <v-col cols="2">
        <v-row align="center" class="mt-5">
          <v-col style="max-width: 180px" class="pa-0">
            <v-col class="pb-0">
              <v-icon size="10" color="blue">mdi-circle</v-icon>
              <span class="legend-text ml-1">План</span>
            </v-col>
            <v-col>
              <v-icon size="10" color="yellow">mdi-circle</v-icon>
              <span class="legend-text ml-1">Факт</span>
            </v-col>
            <v-col align="end" class="ml-10">
              <v-btn rounded="lg" height="3vw" style="font-size: 0.8vw">
                ЭКСПОРТ</v-btn
              >
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.custom-btn {
  background-color: #00a3ff;
  color: white;
  padding: 0.6vw;
  border-radius: 10px;
  width: 90%;
}
.vertical-line-container {
  display: flex;
  width: 100%;
  height: 90%;
  margin-top: 20px;
}
.glowing-line {
  width: 3px;
  background: radial-gradient(
    closest-side,
    #00a3ff,
    white,
    #6ebfef,
    transparent
  );
}
.label-text {
  font-weight: bold;
  font-size: 0.9vw;
}
.legend-text {
  font-size: 0.8vw;
}
</style>
